import React, { PureComponent } from 'react';
import { withRouter } from '../../../../common/utils/NavigationWrapper';

import { List as ListIcon } from '@mui/icons-material';

import { Button, TextField, MenuItem } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

import moment from 'moment';

import Tile from '../../../../common/components/Tile/Tile';
import TableEnhancedContainer from '../../../../common/components/TableEnhanced/TableEnhancedContainer';
import Loading from '../../../../common/components/Loading/Loading';
import Constants from '../../../../common/constants/Constants';

const filterSpacingStyle = { width: '20%', marginRight: '2rem' };

const Filters = (props) => (
  <Tile className="u-mb-full" title="Filters" helpTag={'event_statistics-filters'}>
    <div className="u-fx u-fx-align-end">
      <DatePicker
        slotProps={{
          textField: () => ({
            'data-qa': 'qa-date-from',
          }),
          actionBar: {
            // The actions will be the same between desktop and mobile
            actions: ['cancel', 'accept'],
          },
        }}
        className="u-mr-half"
        closeOnSelect={false}
        style={filterSpacingStyle}
        label="Date from"
        value={props.dateFromFilter}
        placeholder="Date from"
        maxDate={props.dateToFilter}
        onAccept={(date) =>
          props.onChangeDate(
            'dateFromFilter',
            date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          )
        }
        openTo={'year'}
        format={'YYYY-MM-DD'}
      />
      <DatePicker
        slotProps={{
          textField: () => ({
            'data-qa': 'qa-date-to',
          }),
          actionBar: {
            // The actions will be the same between desktop and mobile
            actions: ['cancel', 'accept'],
          },
        }}
        className="u-mr-half"
        closeOnSelect={false}
        style={filterSpacingStyle}
        label="Date to"
        value={props.dateToFilter}
        placeholder="Date to"
        maxDate={moment().add(1, 'days')}
        onAccept={(date) =>
          props.onChangeDate(
            'dateToFilter',
            date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          )
        }
        openTo={'year'}
        format={'YYYY-MM-DD'}
      />
    </div>
    <div className="u-fx u-fx-align-center u-mt-full">
      <TextField
        variant="standard"
        select={true}
        onChange={(event, index, value) =>
          props.onChangeDropDownSelection('selectedEventCategoryFilter', event.currentTarget.id)
        }
        label="Category selector"
        value={props.selectedEventCategoryFilter.displayName}
        data-qa="qa-selectEventCategory"
        className="u-mr-double"
        margin="normal"
      >
        {props.eventCategories
          ? props.eventCategories.map((el, index) => (
              <MenuItem key={index} value={el.displayName} id={index}>
                {el.displayName}
              </MenuItem>
            ))
          : null}
      </TextField>

      <TextField
        variant="standard"
        select={true}
        onChange={(event, index, value) =>
          props.onChangeDropDownSelection('selectedViewModeFilter', event.currentTarget.id)
        }
        label="View mode"
        value={props.selectedViewModeFilter.name}
        data-qa="qa-selectViewMode"
        className="u-mr-double"
        margin="normal"
      >
        {props.viewMode
          ? props.viewMode.map((el, index) =>
              props.selectedEventCategoryFilter.displayName !== 'Reagent offline' ? (
                <MenuItem key={index} value={el.name} id={index}>
                  {el.name}
                </MenuItem>
              ) : el.name === 'by day' ? (
                <MenuItem key={index} value={el.name} id={index}>
                  {el.name}
                </MenuItem>
              ) : null
            )
          : null}
      </TextField>
      <TextField
        variant="standard"
        select={true}
        onChange={(event, index, value) =>
          props.onChangeDropDownSelection('selectedAssayFilter', event.currentTarget.id)
        }
        label="Filter"
        value={props.selectedAssayFilter}
        disabled={!props.isDayViewMode}
        data-qa="qa-selectAssay"
        className="u-mr-double"
        margin="normal"
      >
        {props.assayFilter
          ? props.assayFilter.map((el, index) => (
              <MenuItem key={index} value={el} id={index}>
                {el}
              </MenuItem>
            ))
          : null}
      </TextField>
    </div>

    <div className="u-mt-full u-fx u-fx-align-center">
      <Button
        variant="contained"
        onClick={props.onApplyFilters}
        color="primary"
        disabled={props.isFetching || props.dateTimeErrorMessage}
        data-qa="qa-apply-filters"
      >
        Apply
      </Button>
      {props.metadata ? (
        <p className="u-ml-double u-italic" style={{ color: Constants.COLORS.WARNING }}>
          {props.metadata.Message}
        </p>
      ) : null}
      {props.dateTimeErrorMessage ? (
        <p className="u-ml-double u-italic" style={{ color: Constants.COLORS.ERROR }}>
          {props.dateTimeErrorMessage}
        </p>
      ) : null}
    </div>
  </Tile>
);

class EventStatistics extends PureComponent {
  render() {
    return (
      <div>
        <Filters
          dateFromFilter={this.props.dateFromFilter}
          dateToFilter={this.props.dateToFilter}
          isFetching={this.props.isFetching}
          eventCategories={this.props.eventCategories}
          viewMode={this.props.viewMode}
          assayFilter={this.props.assayFilter}
          onChangeDate={this.props.onChangeDate}
          onApplyFilters={this.props.onApplyFilters}
          selectedEventCategoryFilter={this.props.selectedEventCategoryFilter}
          selectedViewModeFilter={this.props.selectedViewModeFilter}
          selectedAssayFilter={this.props.selectedAssayFilter}
          onChangeDropDownSelection={this.props.onChangeDropDownSelection}
          isDayViewMode={this.props.isDayViewMode}
          metadata={this.props.metadata}
          dateTimeErrorMessage={this.props.dateTimeErrorMessage}
        />
        <Loading condition={this.props.isFetching}>
          <Tile TitleIcon={ListIcon} className="u-mb-full" helpTag={'event_statistics-table'}>
            <TableEnhancedContainer
              columns={this.props.tableConfig}
              data={this.props.tableData}
              enableHideColumns={true}
              enableActionButtons={true}
              instrumentInfo={this.props.instrument.SerialNumber}
              hasFooter={true}
            />
          </Tile>
        </Loading>
      </div>
    );
  }
}

export default withRouter(EventStatistics);
